// Etiquetas en español y English para todos los códigos internos.
// Cada helper acepta un segundo parámetro `lang` ("es" | "en") para devolver
// la traducción correspondiente. Si no se pasa, intenta leer localStorage
// "tb_lang" para decidir automáticamente (útil en helpers usados sin acceso a Context).

const readLang = () => {
    try { return localStorage.getItem("tb_lang") === "en" ? "en" : "es"; }
    catch { return "es"; }
};

export const ORDER_STATUS_LABELS = {
    // Cash
    pending_cash: { es: "Pendiente de Pago", en: "Payment Pending" },
    in_process: { es: "En Proceso", en: "In Process" },
    ready_pickup: { es: "Listo para Recoger", en: "Ready for Pickup" },
    completed: { es: "Completado", en: "Completed" },
    completado: { es: "Completado", en: "Completed" },
    cancelado: { es: "Cancelado", en: "Cancelled" },
    // Transfer
    pending_transfer: { es: "Pendiente de Transferencia", en: "Transfer Pending" },
    payment_received: { es: "Pago Recibido", en: "Payment Received" },
    shipped: { es: "Enviado", en: "Shipped" },
    // Card / PayPal
    paid_new: { es: "Pagado / Nuevo", en: "Paid / New" },
    pending_payment: { es: "Esperando Pago", en: "Awaiting Payment" },
    // Legacy
    pending: { es: "Pendiente", en: "Pending" },
    approved: { es: "Aprobado", en: "Approved" },
    in_transit: { es: "En Tránsito", en: "In Transit" },
    delivered: { es: "Entregado", en: "Delivered" },
};

export const PAYMENT_STATUS_LABELS = {
    unpaid: { es: "Sin Pagar", en: "Unpaid" },
    pending: { es: "Pago Pendiente", en: "Payment Pending" },
    awaiting_confirmation: { es: "Esperando Confirmación", en: "Awaiting Confirmation" },
    paid: { es: "Pagado", en: "Paid" },
    refunded: { es: "Reembolsado", en: "Refunded" },
};

export const PAYMENT_METHOD_LABELS = {
    apartado: { es: "Efectivo en Tienda", en: "Cash in Store" },
    cash: { es: "Efectivo en Tienda", en: "Cash in Store" },
    stripe: { es: "Tarjeta de Crédito/Débito", en: "Credit/Debit Card" },
    paypal: { es: "PayPal", en: "PayPal" },
    transferencia: { es: "Transferencia Bancaria", en: "Bank Transfer" },
};

export const VERIFICATION_STATUS_LABELS = {
    none: { es: "Sin Solicitud", en: "No Request" },
    pending: { es: "Pendiente de Revisión", en: "Pending Review" },
    approved: { es: "Aprobado", en: "Approved" },
    rejected: { es: "Rechazado", en: "Rejected" },
};

export const NOTIFICATION_TYPE_LABELS = {
    order_created: { es: "Pedido Nuevo", en: "New Order" },
    order_apartado: { es: "Apartado en Efectivo", en: "Cash Hold" },
    order_shipping: { es: "Pedido con Envío", en: "Shipping Order" },
    incoming_reservation: { es: "Apartado en Camino", en: "Incoming Reservation" },
    product_request: { es: "Solicitud de Producto", en: "Product Request" },
    verify_request: { es: "Solicitud de Verificación", en: "Verification Request" },
    ticket_new: { es: "Ticket Nuevo", en: "New Ticket" },
    review_new: { es: "Reseña Nueva", en: "New Review" },
};

export const ROLE_LABELS = {
    cliente: { es: "Cliente", en: "Customer" },
    vendedor: { es: "Vendedor", en: "Seller" },
    admin: { es: "Administrador", en: "Administrator" },
};

// Product condition labels shown on the storefront.
export const CONDITION_LABELS = {
    "Nuevo": { es: "Nuevo", en: "New" },
    "Usado": { es: "Usado", en: "Used" },
    "Vendido": { es: "Vendido", en: "Sold" },
};

const pickLabel = (map, key, lang) => {
    const entry = map[key];
    if (!entry) return key ? String(key).replace(/_/g, " ") : "—";
    const l = lang || readLang();
    return entry[l] || entry.es || key;
};

export const statusLabel = (s, lang) => pickLabel(ORDER_STATUS_LABELS, s, lang);
export const paymentStatusLabel = (s, lang) => pickLabel(PAYMENT_STATUS_LABELS, s, lang);
export const paymentMethodLabel = (s, lang) => pickLabel(PAYMENT_METHOD_LABELS, s, lang);
export const verificationLabel = (s, lang) => {
    const entry = VERIFICATION_STATUS_LABELS[s];
    if (!entry) return "—";
    const l = lang || readLang();
    return entry[l] || entry.es;
};
export const notificationTypeLabel = (s, lang) => {
    const entry = NOTIFICATION_TYPE_LABELS[s];
    if (!entry) return s ? String(s).replace(/_/g, " ") : (lang === "en" ? "Notification" : "Notificación");
    const l = lang || readLang();
    return entry[l] || entry.es;
};
export const roleLabel = (s, lang) => pickLabel(ROLE_LABELS, s, lang);
export const conditionLabel = (s, lang) => pickLabel(CONDITION_LABELS, s, lang);
